import React, { useEffect, useState } from 'react';
import Select from "react-select";
import {
    OBJECT_SPECIALS,
    JOB_SEND_REQUESTS,
    ME_LIST_INPUT,
    LOCAL_STORAGE_USER_LOGIN_INFO,
    PersonTypeOptions,
    STANDARD_SEARCH_IGNORE_OPTIONS
} from "@app/constants/Common";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";

const CandidateFlows = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const { changeFlows, onSave } = props
    const { candidate } = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, []);

    const onChangeFlows = (event, fieldName) => {
        if (fieldName === 'object_special' || fieldName === 'job_send_request') {
            candidate[fieldName] = event;
        } else {
            candidate[event.target.name] = event.target.value
        }

        changeFlows(candidate)
        // setCurrCandidate({...currCandidate})
    }

    return (
        <div className='container-fluid'>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Phân luồng</h3>
                    <div className={'card-tools'}>
                        <div className={'text-right'}>
                            <button className='btn btn-primary'
                                type={'button'}
                                onClick={() => onSave()}>
                                <i className='fas fa-save' /> Save
                            </button>
                        </div>
                    </div>
                </div>
                <div className='card-body'>
                    <div className='input-group mt-3'>
                        <label className={'w-100 text-warning'}><b>UV lạ/quen</b></label>
                        <select className='form-control'
                            name={'candidate_know_state'}
                            disabled={candidate.candidate_know_state === '4'}
                            value={candidate.candidate_know_state ? candidate.candidate_know_state : ''}
                            onChange={event => onChangeFlows(event)}>
                            <option value=''>&nbsp;</option>
                            <option value='1'>N/A</option>
                            <option value='2'>UV lạ</option>
                            <option value='3'>UV quen chưa giới thiệu GP</option>
                            <option value='4' disabled={!userLoginInfo.is_superuser}>UV quen đã giới thiệu GP</option>
                        </select>
                        <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='candidate_know_state' />
                    </div>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Đối tượng đặc biệt</b></label>
                        <div style={{ width: '100%' }}>
                            <Select options={OBJECT_SPECIALS} isMulti
                                value={candidate.object_special ? candidate.object_special : ''}
                                name={'object_special'}
                                onChange={value => {
                                    onChangeFlows(value, 'object_special');
                                }}
                            />
                            <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='object_special' />
                        </div>
                    </div>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Yêu cầu gửi job</b></label>
                        <div style={{ width: '100%' }}>
                            <Select options={JOB_SEND_REQUESTS} isMulti
                                value={candidate.job_send_request ? candidate.job_send_request : ''}
                                name={'job_send_request'}
                                onChange={value => {
                                    onChangeFlows(value, 'job_send_request');
                                }}
                            />
                            <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='job_send_request' />
                        </div>
                    </div>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Loại UV khỏi Search tiêu chuẩn</b></label>
                        <select className='form-control'
                            name={'standard_search_ignore'}
                            value={candidate.standard_search_ignore ? candidate.standard_search_ignore : '1'}
                            onChange={event => onChangeFlows(event)}>
                            {STANDARD_SEARCH_IGNORE_OPTIONS.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                        <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='standard_search_ignore' />
                    </div>
                    {userLoginInfo.is_superuser &&
                        <div className='input-group mt-3'>
                            <label className={'w-100'}><b>Nhập list ME</b></label>
                            <select className='form-control'
                                name={'input_me_list'}
                                defaultValue={"1"}
                                value={candidate.input_me_list ? candidate.input_me_list : '1'}
                                onChange={event => onChangeFlows(event)}>
                                {ME_LIST_INPUT.map(item => (
                                    <option value={item.value} key={`me-list-input-${item.value}`}>{item.label}</option>
                                ))}
                            </select>
                            <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='input_me_list' />
                        </div>
                    }
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Block UV</b></label>
                        <select className='form-control'
                            name={'block_state'}
                            value={candidate.block_state ? candidate.block_state : '1'}
                            onChange={event => onChangeFlows(event)}>
                            <option value='1'>Unblock</option>
                            <option value='2'>Blocked</option>
                        </select>
                        <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='block_state' />
                    </div>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Xếp loại UV</b></label>
                        <select className='form-control'
                            name={'candidate_type'}
                            value={candidate.candidate_type ? candidate.candidate_type : '1'}
                            onChange={event => onChangeFlows(event)}>
                            {PersonTypeOptions.map(item => (
                                <option value={item.value}>{item.label}</option>
                            ))}
                        </select>
                        <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='candidate_type' />
                    </div>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}><b>Note (Phân luồng)</b></label>
                        <input type='text' className='form-control'
                            value={candidate.flow_note}
                            name={'flow_note'}
                            onChange={event => onChangeFlows(event)} />
                        <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='flow_note' />
                    </div>
                    {/*<div className='input-group mt-3'>*/}
                    {/*    <label className={'w-100'}><b>Hide/Show</b></label>*/}
                    {/*    <select className='form-control'*/}
                    {/*            name={'show_hide_state'}*/}
                    {/*            value={candidate.show_hide_state ? candidate.show_hide_state : '1'}*/}
                    {/*            onChange={event => onChangeFlows(event)}>*/}
                    {/*        <option value='1'>Show</option>*/}
                    {/*        <option value='2'>Hide loại 1</option>*/}
                    {/*        <option value='3'>Hide loại 2</option>*/}
                    {/*    </select>*/}
                    {/*    <AllUserInputField arrInfo={candidate.allFlowCategoriesInfo} field='show_hide_state'/>*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
};

export default CandidateFlows;
